import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { redirectToPage } from 'srcReact/helpers/history'
import { checkNested } from 'srcReact/helpers/validator'
import { getRedirectUrlForWithoutPlan } from 'srcReact/helpers/organizationHelper'
import { organizationActions } from 'srcReact/OrganizationPage'
import { messengerActions } from 'srcReact/MessengerPage'
import MobileHeader from './components/MobileHeader'
import DesktopHeader from './components/DesktopHeader'
import { getCurrentLanguageFromCookie, uuid } from 'srcReact/helpers/utils'
import history from 'srcReact/helpers/history'
import dayjs from 'dayjs'
import { loginActions } from 'srcReact/LoginPage'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { commonActions } from 'srcReact/components/actions'

function Header(props) {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const {
    alert,
    common: { isMobile, isNative },
    login: { user: loggedInUser },
    profile: { invites },
    organization: { current_organization, organization_list, header, workplace_list, notification_list }
  } = useSelector((state) => state)

  const { messenger, notifications, subscription, sidebar, user_properties, loading } = useSelector((state) => {
    if (state?.organization?.header) {
      return state.organization.header
    }
    return {}
  })

  ///states
  const [orgaSideBarOpened, setOrgaSideBarOpened] = useState(false)
  const excludedRedirectionURL = [
    'organization/settings',
    'callback-checkout',
    'callback-checkout-edit',
    'create-organization',
    'create-or-join-workplace',
    'your-invites',
    'pricing',
    'pricing-non-profit',
    'communities-at-work',
    'settings/account',
    'organization-terms-of-services'
  ]
  const excludedRedirectionURLCreateWP = [
    'organization/settings',
    'callback-checkout',
    'callback-checkout-edit',
    'organizations',
    'about',
    'create-workplace',
    'pricing',
    'pricing-non-profit',
    'settings/account',
    'communities-at-work',
    'organization-terms-of-services'
  ]

  useEffect(() => {
    const currentLanguage = getCurrentLanguageFromCookie()
    dayjs.locale(currentLanguage)
    localStorage.setItem('current_lang', currentLanguage)
  }, [])

  useEffect(() => {
    //if user is not part of any organization, redirect to create organization
    if (organization_list.loaded && organization_list.items && organization_list.items.length === 0) {
      if (!isExistInURL(excludedRedirectionURL)) {
        if (invites.list.length > 0) {
          redirectToPage(`/0/create-or-join-workplace/`, isNative)
        } else {
          redirectToPage(`/0/create-organization/`, isNative)
        }
      }
    }
  }, [organization_list, invites])

  useEffect(() => {
    if (header && header.loaded) {
      if (header.error && localStorage.getItem('request_to_delete')) {
        //once the request to delete is approved by organization manager and if user refreshes the pages,
        //user shoudl be logged out if there is no org left
        //user should be switched to other org if there is any
        if (organization_list && organization_list.items) {
          if (organization_list.items.length <= 1) {
            dispatch(loginActions.userLogout())
          } else {
            dispatch(organizationActions.getByUser(appConstantSettings.ORG_LIST_QTY, true))
          }
        }
      } else {
        //once header is updated with subscription, redirect the user to pricing page if there is no subscription found except some pages
        if (header.subscription === null && !isExistInURL(excludedRedirectionURL)) {
          const redirectPage = getRedirectUrlForWithoutPlan(current_organization)
          redirectToPage(redirectPage, isNative)
        }
        if (
          subscription &&
          subscription.plan &&
          workplace_list &&
          workplace_list.items.length === 0 &&
          !isExistInURL(excludedRedirectionURLCreateWP) &&
          checkNested(current_organization, 'info', 'resourceKey')
        ) {
          dispatch(
            organizationActions.getWorkplaces(current_organization.info.resourceKey, () =>
              redirectToPage(`/0/create-workplace?organization_id=${current_organization.info.resourceKey}`, isNative)
            )
          )
        }
      }

      const isProfilePictureUpdatedRecently = localStorage.getItem('profile_picture_updating')
      if (
        header?.user_properties?.profile_picture &&
        header.user_properties.profile_picture.url !== loggedInUser?.profile_picture &&
        isProfilePictureUpdatedRecently === null
      ) {
        const { is_original, mime_type, original_tag, url } = header.user_properties.profile_picture
        dispatch(loginActions.setPictureDetails(url, original_tag, is_original, mime_type))
      }

      //display banner to refresh the browser if new application version is available
      //display banner only if local storage current_app_version has value, else just store the version from api in local storage
      if (header?.codeVersion?.version) {
        const currentAppVersion = localStorage.getItem('current_app_version')
        if (currentAppVersion === null) {
          localStorage.setItem('current_app_version', header.codeVersion.version)
        } else if (currentAppVersion && currentAppVersion !== header.codeVersion.version && !isNative) {
          localStorage.setItem('current_app_version', header.codeVersion.version)

          dispatch(
            commonActions.updateBannerData({
              id: uuid(),
              wizard: 'Jojo',
              color: '#FEB200',
              duration: -1,
              content: t('global.newCodeVersion'),
              cta: [{ button_url: window.location.href, button_title: t('global.refresh'), hardReload: true }]
            })
          )
        }
      }
    }
  }, [header])

  useEffect(() => {
    //once current organization is set, get header info (subscription, sidebar, badge counts)
    if (current_organization && checkNested(current_organization, 'info', 'id')) {
      if (subscription == null || sidebar == null) {
        const isMessenger = history.location.pathname.match(/messenger/)
        if (!isMessenger) {
          dispatch(messengerActions.getConversationsList(current_organization.info.id, 0))
        }
        dispatch(
          organizationActions.getHeaderInfo(
            current_organization.info.id,
            'subscription,sidebar,popup_display',
            'v2_migration'
          )
        )
      }
    }
  }, [current_organization && current_organization.info && current_organization.info.id])

  const hasCurrentOrganization = () => {
    return current_organization && current_organization.info && current_organization.info.id > 0
  }

  const isExistInURL = (URLList = []) => {
    const urls = URLList.filter((URL) => location.pathname.includes(URL))
    return urls.length > 0
  }

  return (
    <React.Fragment>
      {/* {alert && alert.message ? (
        <AlertContainer
          title={t('error.error_alert_title')}
          message={alert.message}
          show={!!alert.message}
          handleClose={() => dispatch(alertActions.clear())}
        />
      ) : null} */}
      {isMobile && !isNative ? (
        <MobileHeader
          currentOrganization={hasCurrentOrganization() ? current_organization : null}
          loggedInUser={loggedInUser}
          orgaSideBarOpened={orgaSideBarOpened}
          setOrgaSideBarOpened={setOrgaSideBarOpened}
          organizationList={organization_list}
          isNative={isNative}
          messenger={messenger}
          notifications={notifications}
        />
      ) : (
        <DesktopHeader
          currentOrganization={hasCurrentOrganization() ? current_organization : null}
          loggedInUser={loggedInUser}
          orgaSideBarOpened={orgaSideBarOpened}
          setOrgaSideBarOpened={setOrgaSideBarOpened}
          organizationList={organization_list}
          isNative={isNative}
          messenger={messenger}
          notifications={notifications}
        />
      )}
    </React.Fragment>
  )
}

export default Header
